export const UnautorizedPage = (props) => {
    return (
        <>
        <h1> Jūs neturite prieigos teisių šiam puslapiui</h1>
        </>
    )
}